import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { cn } from "@/shared/lib/cn";

/**
 * The search field of mobile tab screens (home, catalog): looks like an input, opens the full-screen search
 * (/search, D11). 44 px, grey fill, 16 px text.
 */
export function SearchEntry({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <Link
      to="/search"
      className={cn(
        "flex h-11 items-center gap-2 rounded-xl bg-canvas px-3 text-base text-muted active:bg-line",
        className,
      )}
    >
      <Search className="size-5 shrink-0" aria-hidden />
      <span className="truncate">{t("searchPlaceholder")}</span>
    </Link>
  );
}
